export const NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_LOADING =
  'NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_LOADING';
export const NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_SUCCESS =
  'NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_SUCCESS';
export const NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_ERROR =
  'NUTRITIONSTANDARDSREPORT_GETNUTRITIONSTANDARDS_ERROR';




// WEBPACK FOOTER //
// ./src/pages/nutritionstandardsreport/state/types.js